module.exports = __webpack_public_path__ + "img/germany.ac4d7801.svg";